import { motion } from "framer-motion";
import { ScrollText } from "lucide-react";
import SectionHeader from "./SectionHeader";

const CHARTER_URL = "/charter";

const CHAPTERS = [
  {
    numeral: "I",
    number: "01",
    title: "Sovereignty Beyond Borders",
    copy: "The borders drawn across our continent were never drawn by us. The United States of Africa dissolves them — not with conflict, but with a signature, a seal, and a passport carried by every citizen.",
  },
  {
    numeral: "II",
    number: "02",
    title: "The Economic Engine",
    copy: "No borders for the youth, no borders for business. From Dakar to Mombasa, traders of every industry move goods, capital, and ideas freely among ourselves — one market of 1.5 billion people.",
  },
  {
    numeral: "III",
    number: "03",
    title: "Youth Supremacy",
    copy: "The African Youth Parliament of the United States of Africa is not a council of tomorrow — it governs today. Young delegates shape the laws of movement, trade, and opportunity across 55 states.",
  },
  {
    numeral: "IV",
    number: "04",
    title: "The Pan-African Blueprint",
    copy: "One passport. One parliament. One destiny. Initiated by the Kingdom of Kush, carried by the diaspora, and open to every African who believes this continent must move forward — together.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="py-20 lg:py-32 bg-[#0D1013] noise-overlay relative" data-testid="manifesto-section">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
        <SectionHeader
          kicker="The Manifesto"
          title="Four Chapters of a Borderless Continent"
          copy="The founding doctrine of the Union — read it, carry it, ratify it with your name."
        />
        <motion.a
          href={CHARTER_URL}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          data-testid="read-charter-btn"
          className="mt-8 inline-flex items-center gap-3 rounded-full bg-[#00A651] text-[#0A0C0E] font-display font-bold text-sm px-7 py-4 hover:bg-[#2FC36A] hover:shadow-[0_0_32px_rgba(0,166,81,0.4)] transition-all duration-300"
        >
          <ScrollText className="w-4 h-4" />
          Read The Full Charter — 13 Chapters
        </motion.a>
        <div className="mt-16 space-y-0">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.number}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="grid md:grid-cols-12 gap-6 md:gap-12 items-start border-t border-[#00A651]/15 py-14 last:border-b"
              data-testid={`manifesto-chapter-${i + 1}`}
            >
              <div className="md:col-span-3 flex md:block items-baseline gap-4">
                <span className="font-display font-extrabold text-5xl lg:text-6xl text-outline-gold leading-none">
                  {c.number}
                </span>
                <p className="font-official text-[11px] tracking-[0.35em] uppercase text-[#00A651] md:mt-4">
                  Chapter {c.numeral}
                </p>
              </div>
              <div className="md:col-span-9">
                <h3 className="font-display font-extrabold tracking-tight text-xl sm:text-2xl text-[#F7F5F0]">
                  {c.title}
                </h3>
                <p className="text-base sm:text-lg text-[#8A99AD] leading-relaxed mt-4 max-w-2xl">{c.copy}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
